module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAqCAYAAACZSYp/AAAAF0lEQVQoU2M8ffr0fwYGBgbGUQZ9AwEA3NSN6xDRngsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/device/long_string_icon.png
// module id = yCPw
// module chunks = 1